import React from 'react';
import loadable from '@loadable/component';

const LoadingSpinner = loadable(() =>
  import('../../../components/loading_spinner/loading_spinner')
);

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('./recognition_hub').default;
}

// eslint-disable-next-line
export default function(store) {
  const routeConfig = {
    path: '/lists',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk() {
      return import('./recognition_hub').then(resp => {
        Component = resp.default;
        return Component;
      });
    },
    chunk: 'recognitionHub'
  };

  const LazyComponent = loadable(() => routeConfig.preloadChunk(), {
    fallback: (
      <section className="recognition-hub-page">
        <article className="recognition-hub-page-main">
          <LoadingSpinner />
        </article>
      </section>
    )
  });

  return routeConfig;
}
